// extracted by mini-css-extract-plugin
export default {"container":"callback_container__oRRHk","card":"callback_card__50gk8","title":"callback_title__MddxS","text":"callback_text__izQ5k"};